import { Component, OnInit } from '@angular/core';
import { HlProductCardListGridViewComponent } from '../hl-product-card-list-grid-view/hl-product-card-list-grid-view.component';
import { first } from 'rxjs';

@Component({
    selector: 'app-hl-product-compressed-list-view',
    templateUrl: './hl-product-compressed-list-view.component.html',
    styleUrl: './hl-product-compressed-list-view.component.css',
    standalone: false
})
export class HlProductCompressedListViewComponent extends HlProductCardListGridViewComponent implements OnInit {
  public isCustomerService: boolean = false;

  public ngOnInit(): void {
    super.ngOnInit();
    this.authService.getHasRoles('CUSTOMER_SERVICE').pipe(first()).subscribe(result => this.isCustomerService = result);
  }
}
